import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, Box, OutlinedInput, Typography, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Slide from "@mui/material/Slide";
import notifier from "../Notifier";
import LockIcon from "@mui/icons-material/Lock";
import {
  checkExtension,
  getErrorString,
  isEmpty,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import { Upload } from "react-iconly";
import Loader from "../Loader";
import { getUserId } from "./../../constants/function";
import PageHeader from "./../../components/PageHeader";
import NoData from "./../../components/Nodata";
import DoneIcon from "@mui/icons-material/Done";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddMusicToPlaylist(props) {
  const { t } = useTranslation("common");
  const [id, setId] = React.useState(null);
  const [playlist, setPlaylist] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const [search, setSearch] = React.useState("");

  // The whole list comes back in one response, so filtering here is instant
  // and needs no extra request. The server already orders it by plays.
  const term = search.trim().toLowerCase();
  const visible = term
    ? (playlist || []).filter((p) => (p?.title || "").toLowerCase().includes(term))
    : playlist || [];
  const getPlaylist = async (_id, next) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_ALL_(_id);
      setLoading(false);
      // setLoaded(response["result"].length < 10 ? true : false);
      setPlaylist(response["result"]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getAlbums = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.MY_ALBUM(`${_id}`);
      setLoading(false);
      setPlaylist([...response["result"]]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const save = async (playlistId) => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_SONG_TO_PLAYLIST({
        musicId: props["musicId"],
        playlistId: playlistId,
        // The studio the song was found in, when it is someone else's: the
        // server records a discovery for both people.
        ...(props.fromPlaylistId ? { fromPlaylistId: props.fromPlaylistId } : {}),
      });
      notifier.success(t("notifier.success.toast19"));
      setLoading(false);
      props.handleClose();
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  const saveToAlbum = async (albumId) => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_SONGS_TO_ALBUM({
        musicId: props["musicId"],
        albumId: albumId,
      });
      notifier.success(t("notifier.success.toast19"));
      setLoading(false);
      props.handleClose();
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  React.useEffect(() => {
    if (props["isAlbum"]) getAlbums(getUserId());
    else getPlaylist(getUserId(), pageNo);
  }, []);
  const handleScroll = async (target) => {
    if (props["isAlbum"]) return;
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getPlaylist(getUserId(), next);
    }
  };
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(null, true)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(null, false)}
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            backgroundColor: "rgb(0 0 0)",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            height: "80vh",
            margin: "0",
            width: "100%",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1} sx={{ height: "inherit" }}>
          <Typography className="text-center p-10">
            {props["isAlbum"] ? t("dropMenu.m4") : t("dropMenu.m3")}
          </Typography>
          <Stack
            sx={{ padding: "16px", height: "calc(100% - 83px)" }}
            spacing={1}
            className="p55"
          >
            {playlist?.length > 0 && !props["isAlbum"] ? (
              <OutlinedInput
                fullWidth
                size="small"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t("addToStudio.searchPlaceholder", "Search your studios")}
                inputProps={{ "aria-label": "Search your studios" }}
                startAdornment={
                  <SearchIcon sx={{ color: "rgba(255,255,255,0.4)", fontSize: 18, mr: 1 }} />
                }
                sx={{
                  borderRadius: "25px",
                  background: "#1A1A1A",
                  color: "#fff",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
                }}
              />
            ) : null}
            <Stack
              // onScroll={(e) => handleScroll(e.target)}
              spacing={1}
              sx={{
                minHeight: "calc(100% - 100px)",
                overflow: "scroll",
                paddingBottom: "50px",
              }}
            >
              {visible.length > 0 ? (
                visible.map((p, index) => (
                  <Stack
                    style={{
                      cursor: "pointer",
                      borderRadius: "25px",
                      background: id === p["_id"] ? "#262626" : "#1A1A1A",
                      padding: "10px",
                    }}
                    direction="row"
                    alignItems="center"
                    gap="10px"
                    key={index}
                    onClick={() =>
                      setId(id && id === p["_id"] ? null : p["_id"])
                    }
                  >
                    <Typography>{p["title"]}</Typography>
                    {p["private"] && !props["isAlbum"] ? (
                      <LockIcon className="__small_icon" />
                    ) : null}
                    {/* The list is ordered by plays, so show the number the
                        order is based on rather than leaving it unexplained. */}
                    {!props["isAlbum"] && p["listens"] > 0 ? (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "rgba(255,255,255,0.45)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {Math.round(p["listens"]).toLocaleString()} plays
                      </Typography>
                    ) : null}
                    {id === p["_id"] ? (
                      <DoneIcon
                        className="bg_primary ml_auto br-50 fs-14 p2"
                        color="secondary"
                      />
                    ) : null}
                  </Stack>
                ))
              ) : term ? (
                <NoData lable={`No studio matches "${search.trim()}"`} />
              ) : (
                <NoData
                  lable={
                    props["isAlbum"]
                      ? t("noData.message2")
                      : t("noData.message3")
                  }
                />
              )}
            </Stack>
            {playlist?.length > 0 ? (
              <Button
                startIcon={<AddIcon color="secondary" />}
                variant="contained"
                color="primary"
                // Nothing picked used to post a null id and fail at the server.
                disabled={!id}
                onClick={() => (props["isAlbum"] ? saveToAlbum(id) : save(id))}
              >
                {props["isAlbum"] ? t("dropMenu.m4") : t("dropMenu.m3")}
              </Button>
            ) : null}
          </Stack>
        </Stack>
        {loading ? (
          <Loader
            wait={true}
            message={
              props["isAlbum"]
                ? t("loader.message3")
                : `${t("loader.message27")} ${
                    pageNo > 1 ? t("loader.message5") : ""
                  } ${t("loader.message6")}`
            }
          />
        ) : null}
      </Dialog>
    </div>
  );
}
